export enum CommonHelpersTriggerGtmEventsLocationsEnum {
  myApps = 'MyApps',
  appMarket = 'AppMarket',
  appDetails = 'AppDetails',
  browseApps = 'BrowseApps',
}
